// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2ZIUA","right":"styles_right__3OZbl"};